export const QUESTION_TYPES = {
  RADIO: "radio",
  TEXT: "text",
}

export const SURVEY_IDS = {
  BLOCK_SURVEY: 1,
  CYCLE_SURVEY: 2,
}